import { useState } from "react";
import { api } from "../api";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { ErrorNote, Field, errorText } from "../ui";

/** (Task Q) Signed in with a temporary password from the owner → choose your own before anything else. */
export function MustChangePassword() {
  const { me, refresh } = useAuth();
  const { t } = useI18n();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  if (!me?.mustChangePassword) return null;
  const save = async () => {
    setBusy(true); setErr(null);
    try { await api("/api/auth/change-password", { method: "POST", body: { current: cur, password: pw } }); await refresh(); }
    catch (e) { setErr(errorText(e)); } finally { setBusy(false); }
  };
  return (
    <div className="overlay dialog-overlay" role="dialog" aria-modal="true" aria-label={t("tq.login.mustChange")} data-testid="must-change-pw">
      <div className="dialog">
        <h2>{t("tq.login.mustChange")}</h2>
        <p className="muted">{t("tq.login.mustChangeSub")}</p>
        <ErrorNote text={err} />
        <Field label={t("tq.login.current")}><input type="password" autoComplete="current-password" value={cur} onChange={(e) => setCur(e.target.value)} /></Field>
        <Field label={t("tq.login.new")}><input type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} /></Field>
        <button className="btn btn-primary btn-block" disabled={busy || !cur || pw.length < 8} onClick={() => void save()}>{t("tq.login.change")}</button>
      </div>
    </div>
  );
}
